import { c as _c } from "react/compiler-runtime";
import { IcoCrosshair24, IcoLayer0124 } from '@onefootprint/icons';
import { Divider, Form, InlineAlert } from '@onefootprint/ui';
import { cx } from 'class-variance-authority';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import type { VerificationCheckFormValues } from './verification-check.types';
type UserAmlFormProps = {
  disabled?: boolean;
};
const UserAmlForm = t0 => {
  const $ = _c(34);
  const {
    disabled: t1
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      keyPrefix: "verificationChecks.aml"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t2);
  const {
    register,
    setValue,
    control
  } = useFormContext();
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = ["aml.enhancedAml", "aml.ofac", "aml.pep", "aml.adverseMedia", "aml.matchingMethod"];
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== control) {
    t4 = {
      control,
      name: t3
    };
    $[2] = control;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const [isEnhancedAml, ofac, pep, adverseMedia, matchingMethod] = useWatch(t4);
  const noAmlOptionSelected = !ofac && !pep && !adverseMedia;
  const showAmlError = isEnhancedAml && noAmlOptionSelected;
  let t5;
  if ($[4] !== setValue) {
    t5 = checked => {
      setValue("aml.enhancedAml", checked);
      setValue("aml.ofac", checked);
      setValue("aml.pep", checked);
      setValue("aml.adverseMedia", checked);
      setValue("aml.hasOptionSelected", undefined);
      setValue("aml.adverseMediaList", {
        financial_crime: checked,
        violent_crime: checked,
        sexual_crime: checked,
        cyber_crime: checked,
        terrorism: checked,
        fraud: checked,
        narcotics: checked,
        general_serious: checked,
        general_minor: checked
      });
      setValue("aml.matchingMethod", {
        kind: "fuzzy",
        fuzzyLevel: "fuzzy_low",
        exactLevel: "exact_name"
      });
    };
    $[4] = setValue;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const handleAmlToggle = t5;
  let t6;
  if ($[6] !== t) {
    t6 = t(_temp);
    $[6] = t;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t) {
    t7 = t(_temp2);
    $[8] = t;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== handleAmlToggle) {
    t8 = checked_0 => handleAmlToggle(checked_0);
    $[10] = handleAmlToggle;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== disabled || $[13] !== t6 || $[14] !== t7 || $[15] !== t8) {
    t9 = <Form.Toggle name="aml.enhancedAml" label={t6} hint={t7} size="compact" disabled={disabled} onChange={t8} />;
    $[12] = disabled;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== adverseMedia || $[18] !== disabled || $[19] !== isEnhancedAml || $[20] !== matchingMethod || $[21] !== setValue || $[22] !== t) {
    t10 = isEnhancedAml && <><Divider variant="secondary" /><SectionHeader><IcoCrosshair24 />{t(_temp3)}</SectionHeader><Form.Checkbox label={t(_temp4)} hint={t(_temp5)} disabled={disabled} name="aml.ofac" /><Form.Checkbox label={t(_temp6)} hint={t(_temp7)} disabled={disabled} name="aml.pep" /><Form.Checkbox label={t(_temp8)} hint={t(_temp9)} disabled={disabled} name="aml.adverseMedia" onChange={event => {
        const checked_1 = event.target.checked;
        setValue("aml.adverseMediaList", {
          financial_crime: checked_1,
          violent_crime: checked_1,
          sexual_crime: checked_1,
          cyber_crime: checked_1,
          terrorism: checked_1,
          fraud: checked_1,
          narcotics: checked_1,
          general_serious: checked_1,
          general_minor: checked_1
        });
      }} />{adverseMedia ? <div className="flex flex-col gap-2 ml-6"><Form.Checkbox name="aml.adverseMediaList.financial_crime" label={t(_temp10)} disabled={disabled} /><Form.Checkbox name="aml.adverseMediaList.violent_crime" label={t(_temp11)} disabled={disabled} /><Form.Checkbox name="aml.adverseMediaList.sexual_crime" label={t(_temp12)} disabled={disabled} /><Form.Checkbox name="aml.adverseMediaList.cyber_crime" label={t(_temp13)} disabled={disabled} /><Form.Checkbox name="aml.adverseMediaList.terrorism" label={t(_temp14)} disabled={disabled} /><Form.Checkbox name="aml.adverseMediaList.fraud" label={t(_temp15)} disabled={disabled} /><Form.Checkbox name="aml.adverseMediaList.narcotics" label={t(_temp16)} disabled={disabled} /><Form.Checkbox name="aml.adverseMediaList.general_serious" label={t(_temp17)} disabled={disabled} /><Form.Checkbox name="aml.adverseMediaList.general_minor" label={t(_temp18)} disabled={disabled} /></div> : null}<Divider variant="secondary" /><div className="flex flex-col"><SectionHeader className="mb-4"><IcoLayer0124 />{t(_temp19)}</SectionHeader><div className="flex flex-col gap-3"><Form.Radio name="aml.matchingMethod.kind" value="fuzzy" label={t(_temp20)} hint={t(_temp21)} disabled={disabled} />{matchingMethod.kind === "fuzzy" ? <div className="flex flex-col gap-3 ml-6"><Form.RadioGroup name="aml.matchingMethod.fuzzyLevel" options={[{
              label: t(_temp22),
              value: "fuzzy_low",
              hint: t(_temp23)
            }, {
              label: t(_temp24),
              value: "fuzzy_medium",
              hint: t(_temp25)
            }, {
              label: t(_temp26),
              value: "fuzzy_high",
              hint: t(_temp27)
            }]} disabled={disabled} /></div> : null}<Form.Radio name="aml.matchingMethod.kind" value="exact" label={t(_temp28)} hint={t(_temp29)} disabled={disabled} />{matchingMethod.kind === "exact" ? <div className="flex flex-col gap-3 ml-6"><Form.RadioGroup name="aml.matchingMethod.exactLevel" options={[{
              label: t(_temp30),
              value: "exact_name"
            }, {
              label: t(_temp31),
              value: "exact_name_and_dob_year"
            }]} disabled={disabled} /></div> : null}</div></div><Divider variant="secondary" /><Form.Checkbox name="aml.continuousMonitoring" label={t(_temp32)} disabled={disabled} /></>;
    $[17] = adverseMedia;
    $[18] = disabled;
    $[19] = isEnhancedAml;
    $[20] = matchingMethod;
    $[21] = setValue;
    $[22] = t;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t10 || $[25] !== t9) {
    t11 = <div className="flex flex-col gap-4">{t9}{t10}</div>;
    $[24] = t10;
    $[25] = t9;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== register || $[28] !== showAmlError || $[29] !== t) {
    t12 = showAmlError && <><input type="hidden" {...register("aml.hasOptionSelected", {
        required: true
      })} /><InlineAlert variant="warning">{t(_temp33)}</InlineAlert></>;
    $[27] = register;
    $[28] = showAmlError;
    $[29] = t;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== t11 || $[32] !== t12) {
    t13 = <div className="flex flex-col gap-4 whitespace-pre-wrap">{t11}{t12}</div>;
    $[31] = t11;
    $[32] = t12;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  return t13;
};
const SectionHeader = t0 => {
  const $ = _c(10);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = cx("flex text-label-2 text-primary items-center gap-1", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== children || $[7] !== props || $[8] !== t1) {
    t2 = <div className={t1} {...props}>{children}</div>;
    $[6] = children;
    $[7] = props;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
};
export default UserAmlForm;
function _temp($) {
  return $.aml.label;
}
function _temp2($_0) {
  return $_0.aml.hint;
}
function _temp3($_1) {
  return $_1.screening.title;
}
function _temp4($_2) {
  return $_2.screening.ofac.label;
}
function _temp5($_3) {
  return $_3.screening.ofac.hint;
}
function _temp6($_4) {
  return $_4.screening.pep.label;
}
function _temp7($_5) {
  return $_5.screening.pep.hint;
}
function _temp8($_6) {
  return $_6.screening.adverseMedia.label;
}
function _temp9($_7) {
  return $_7.screening.adverseMedia.hint;
}
function _temp10($_8) {
  return $_8.screening.adverseMediaList.financialCrime;
}
function _temp11($_9) {
  return $_9.screening.adverseMediaList.violentCrime;
}
function _temp12($_10) {
  return $_10.screening.adverseMediaList.sexualCrime;
}
function _temp13($_11) {
  return $_11.screening.adverseMediaList.cyberCrime;
}
function _temp14($_12) {
  return $_12.screening.adverseMediaList.terrorism;
}
function _temp15($_13) {
  return $_13.screening.adverseMediaList.fraud;
}
function _temp16($_14) {
  return $_14.screening.adverseMediaList.narcotics;
}
function _temp17($_15) {
  return $_15.screening.adverseMediaList.generalSerious;
}
function _temp18($_16) {
  return $_16.screening.adverseMediaList.generalMinor;
}
function _temp19($_17) {
  return $_17.matchingMethod.title;
}
function _temp20($_18) {
  return $_18.matchingMethod.fuzzy.label;
}
function _temp21($_19) {
  return $_19.matchingMethod.fuzzy.hint;
}
function _temp22($_20) {
  return $_20.matchingMethod.fuzzyLevels.low.label;
}
function _temp23($_21) {
  return $_21.matchingMethod.fuzzyLevels.low.hint;
}
function _temp24($_22) {
  return $_22.matchingMethod.fuzzyLevels.medium.label;
}
function _temp25($_23) {
  return $_23.matchingMethod.fuzzyLevels.medium.hint;
}
function _temp26($_24) {
  return $_24.matchingMethod.fuzzyLevels.high.label;
}
function _temp27($_25) {
  return $_25.matchingMethod.fuzzyLevels.high.hint;
}
function _temp28($_26) {
  return $_26.matchingMethod.exact.label;
}
function _temp29($_27) {
  return $_27.matchingMethod.exact.hint;
}
function _temp30($_28) {
  return $_28.matchingMethod.exactLevels.name.label;
}
function _temp31($_29) {
  return $_29.matchingMethod.exactLevels.nameAndDob.label;
}
function _temp32($_30) {
  return $_30.screening.continuousMonitoring;
}
function _temp33($_31) {
  return $_31.missingSelection;
}